import { useContext, ReactNode, useState, useEffect } from 'react';
import styled from 'styled-components';

import { IoCalendarOutline } from 'react-icons/io5';
import { HiOutlineClock } from 'react-icons/hi';
import { color } from 'ui';

import AppText from '../../shared/AppText';
import { ContainerProps } from './Body';
import { LayoutContext } from '../../contexts/LayoutContext';

interface SubHeaderProps {
  breadCrumbs?: ReactNode;
}

const SubHeader = ({ breadCrumbs }: SubHeaderProps) => {
  const { collapsed } = useContext(LayoutContext);
  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const today = new Date();
    setCurrentDate(formatDate(today));
  }, []);

  useEffect(() => {
    const formatTime = (date: Date): string => {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      const formattedHours = hours % 12 || 12; 
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

      const period = hours >= 12 ? 'pm' : 'am';

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${period}`;
    };

    const updateTime = () => {
      const now = new Date();
      setCurrentTime(formatTime(now));
    };

    const interval = setInterval(updateTime, 1000); 
    updateTime();
    return () => clearInterval(interval);
  }, []); 


  return (
    <Container collapsed={collapsed}>
      {breadCrumbs}
      <LeftDiv>
        <TextDiv>
          <IoCalendarOutline color={color.black} />
          <AppText color={color.black}>{currentDate}</AppText>
        </TextDiv>
        <TextDiv>
          <HiOutlineClock color={color.black} />
          <AppText color={color.black}>{currentTime}</AppText>
        </TextDiv>
      </LeftDiv>
    </Container>
  );
};

export default SubHeader;

const Container = styled.div<ContainerProps>`
  background: #fff;
  position: fixed;
  top: 72px;
  height: 46px;
  display: flex;
  z-index: 99;
  align-items: center;
  justify-content: space-between;
  padding-left: ${({ collapsed }) => (collapsed ? '100px' : '324px')};
  padding-right: 2rem;
  box-sizing: border-box;
  width: 100%;
  transition: padding-left 0.3s ease-out;
`;

const LeftDiv = styled.div`
  display: flex;
  gap: 1.5rem;
`;
const TextDiv = styled.div`
  display: flex;
  gap: 0.7rem;
  align-items: center;
`;
